import { errorMetaOf, toUserMessage } from '../api/errors.js';
import { Button } from './Button.js';

export interface ErrorStateProps {
  error: unknown;
  title?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

/**
 * 错误态：必须显示「具体原因 + 错误码 + 下一步」。
 * 与 Toast 的分工：本组件用于"整块数据加载失败"，Toast 用于"操作失败但仍可继续"。
 */
export function ErrorState({ error, title = '加载失败', onRetry, retryLabel = '重试' }: ErrorStateProps) {
  const message = toUserMessage(error);
  const meta = errorMetaOf(error);
  return (
    <div className="error-box" role="alert">
      <div className="error-title">{title}</div>
      <p className="error-msg wrap-anywhere">{message}</p>
      {meta !== null ? <p className="error-meta">{meta}</p> : null}
      {onRetry !== undefined ? (
        <div className="row">
          <Button variant="secondary" size="sm" onClick={onRetry}>
            {retryLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
}